import initializeStyleGuideExternalApi from './register-style-guide-api'

export { default as SeamlyStaticCore } from './components/static-core'

export default initializeStyleGuideExternalApi
